import { AppCrashBoundary } from '../shared/errors/AppCrashBoundary'
import { YandexMetrika } from '../platform/analytics/YandexMetrika'
import { PwaUpdatePrompt } from '../platform/pwa/PwaUpdatePrompt'
import { AppProviders } from './providers/AppProviders'
import { appRouter } from './router/router'

export function App() {
  return (
    <>
      <AppCrashBoundary>
        <AppProviders router={appRouter} />
      </AppCrashBoundary>
      <YandexMetrika />
      <PwaUpdatePrompt />
    </>
  )
}
